/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Suggestion } from './Suggestion';
import {
    SuggestionFromJSON,
    SuggestionFromJSONTyped,
    SuggestionToJSON,
} from './Suggestion';

/**
 * Representation of a Suggestion List
 * @export
 * @interface SuggestionList
 */
export interface SuggestionList {
    /**
     * List of suggestions
     * @type {Array<Suggestion>}
     * @memberof SuggestionList
     */
    suggestions?: Array<Suggestion>;
}

/**
 * Check if a given object implements the SuggestionList interface.
 */
export function instanceOfSuggestionList(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SuggestionListFromJSON(json: any): SuggestionList {
    return SuggestionListFromJSONTyped(json, false);
}

export function SuggestionListFromJSONTyped(json: any, ignoreDiscriminator: boolean): SuggestionList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'suggestions': !exists(json, 'suggestions') ? undefined : ((json['suggestions'] as Array<any>).map(SuggestionFromJSON)),
    };
}

export function SuggestionListToJSON(value?: SuggestionList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'suggestions': value.suggestions === undefined ? undefined : ((value.suggestions as Array<any>).map(SuggestionToJSON)),
    };
}

